import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-256fb81d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "积分充值", -1))
const _hoisted_2 = { class: "body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "充值金额", -1))
const _hoisted_4 = { class: "money-wrapper d-flex" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "d-flex-1f input-opt-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "支付方式", -1))
const _hoisted_8 = { class: "pay-way-wrapper" }
const _hoisted_9 = {
  key: 0,
  class: "pay-way-item"
}
const _hoisted_10 = {
  key: 1,
  class: "pay-way-item"
}
const _hoisted_11 = { class: "bottom-wrapper" }

import { ref } from "vue";
import { Toast as toast } from 'vant'
import { powerVerifyByStore } from "@/modular/Session";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'RechargeView',
  props: {

    payType: {
        type: Number,
        default: 1,
    },
},
  emits: ["submitRecharge"],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore();
const amountinputRef = ref<HTMLInputElement>(null);
const show = ref(false);
const moneyOpt = ref([10, 50, 100]);
const activeMoney = ref(10);//选中的金额
const amountModel = ref(0);
/**
* 按钮的loading状态
*/
const btnLoading = ref(false);

const emits = __emit;

const props = __props;




async function open(amount) {
    // if ((await powerVerifyByStore(store)) == false) {
    //     return;
    // }

    show.value = true;
    btnLoading.value = false;
    amountModel.value = amount;
    if (amountModel.value > 0) {
        activeMoney.value = null;
    }
}

__expose({
    open
});

function activeOpt(el) {
    if (el == activeMoney.value) {
        activeMoney.value = null;
    } else {
        activeMoney.value = el;
    }
    amountModel.value = null;
}
function input() {
    activeMoney.value = null;


}
function inputEnter() {
    btnLoading.value = true;
    try {
        amountinputRef.value?.blur();

        if (amountModel.value) {
            activeMoney.value = null;
        }
        submit(amountModel.value || activeMoney.value);

    } catch (error) {
        console.log("充值报错", error);
    } finally {
        btnLoading.value = false;
    }
}
/**
 * 现金捐赠
 */
function submit(val) {
    if (!val) {
        toast.fail("请输入正确的充值金额");
        return;
    }

    // 正则判断小数
    if (val <= 0 || /^\d+$/.test(val) == false) {
        toast.fail("请正确输入您的充值金额");
        return;
    }

    emits("submitRecharge", val, () => {
        close();
    });
}



function close() {
    show.value = false;
    btnLoading.value = false;
}



return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    teleport: "body",
    show: show.value,
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((show).value = $event)),
    closeable: "",
    "close-icon": "close",
    position: "bottom",
    class: "d-flex-column d-overflow-not"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moneyOpt.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["opt d-flex-1f", { active: item == activeMoney.value }]),
              key: item,
              onClick: ($event: any) => (activeOpt(item))
            }, _toDisplayString(item), 11, _hoisted_5))
          }), 128)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[0] || (_cache[0] = ($event: any) => (input())),
              ref_key: "amountinputRef",
              ref: amountinputRef,
              class: "amountinput",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (inputEnter()), ["enter"])),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((amountModel).value = $event)),
              type: "number",
              maxlength: "4"
            }, null, 544), [
              [_vModelText, amountModel.value]
            ])
          ])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (__props.payType == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_van_icon, { name: " iconfont d-weixinzhifu" }),
                _createTextVNode("微信支付 ")
              ]))
            : _createCommentVNode("", true),
          (__props.payType == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 广益支付 "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_van_button, {
          type: "primary",
          class: "btn",
          loading: btnLoading.value,
          "loading-text": "立即充值",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (inputEnter())),
          block: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("立即充值")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})